import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Fetch data from .env file
const {
  REACT_APP_API_KEY,
  REACT_APP_AUTH_DOMAIN,
  REACT_APP_PROJECT_ID,
  REACT_APP_STORAGE_BUCKET,
  REACT_APP_MESSAGING_SENDER_ID,
  REACT_APP_APP_ID,
} = process.env;

// configuration of firebase
const firebaseConfig = {
  apiKey: "AIzaSyAvGw95CsLxflQPRq3yWXV3BwHSoGlr4AM",
  authDomain: "nti-shop.firebaseapp.com",
  projectId: "nti-shop",
  storageBucket: "nti-shop.appspot.com",
  messagingSenderId: "284243685893",
  appId: "1:284243685893:web:5943493f3e678c9b66a26c",
};

// Initialize firebase app
const app = initializeApp(firebaseConfig);

// Initialize authentification
const auth = getAuth(app);
auth.languageCode = "fr";

// Initialize database
const db = getFirestore(app);

// Initialize storage
const storage = getStorage(app);

export { app, auth, db, storage };
